import React, {Component} from 'react';
import ItemContainer from './ItemContainer';
import {ItemDetail} from './ItemDetail';


export default class NewItem extends Component {

    render() {
        return (
            <ItemContainer>
                <ItemDetail/>
            </ItemContainer>
        )
    }

}
